// extracted by mini-css-extract-plugin
export default {"root":"Default_root_ZGvVT","title":"Default_title_S_8lH","text":"Default_text_XkGFw","close":"Default_close_jPoqs","icon":"Default_icon_vRMlC"};